import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useUserAppConfig() {
  var queryApi = useDeviceQueryApi();
  return queryApi.useUserAppConfigQuery();
}